import { render, staticRenderFns } from "./Grupos.vue?vue&type=template&id=05682c59&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"
import style0 from "./Grupos.vue?vue&type=style&index=0&id=05682c59&prod&lang=scss"
import style1 from "./Grupos.vue?vue&type=style&index=1&id=05682c59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05682c59",
  null
  
)

export default component.exports